export default __webpack_public_path__ + "static/media/logo.e5f1d285.png";